(function(angular) {
  'use strict';

  var app = angular.module('asDemandMgr');

  app.service('importApi', [
    '$http',
    '$q',
    function($http, $q) {
      this.getList = function(sort, search, page) {
        var url = '/demandmgr/import/list';

        url = url + '?sortField=' + sort.field;
        url = url + '&sortOrder=' + sort.order;
        url = url + '&search=' + search;
        url = url + '&pageNumber=' + page.number;
        url = url + '&pageSize=' + page.size;

        return $q(function(resolve, reject) {
          $http.get(url).then(
            // success
            function(res) {
              resolve(res.data);
            },
            // error
            function(res) {
              console.log(res);

              reject({ code: res.data.errorCode, message: res.data.message });
            }
          );
        });
      };

        this.getDetails = function(iId) {
            var url = '/demandmgr/import/details?id=' + iId;

            return $q(function(resolve, reject) {
                $http.get(url).then(
                    // success
                    function(res) {
                        resolve(res.data);
                    },
                    // error
                    function(res) {
                        reject();
                    }
                );
            });
        };



      this.import = function(data) {
        var url = '/demandmgr/import/import';

        return $q(function(resolve, reject) {
          $http.post(url, data, {
                  transformRequest: angular.identity,
                  headers: {'Content-Type': undefined}
          }).then(
            // success
            function(res) {
              if (res.data.status === "success") {
                resolve(res.data);
              } else {
                reject(res.data.message);
              }
            },
            // error
            function(res) {
              reject("Request error");
            }
          );
        });
      };

    },
  ]);
})(window.angular);
